import { FC } from "react";
import { NameFieldValue } from "../Fields/types/fieldTypes";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAvatar } from "./useAvatar";

export interface AvatarProps {
  imageSrc?: string;
  imageAltText?: string;
  circleText?: string;
  firstAndLastName?: NameFieldValue;
  fullName?: string;
  iconClassName?: string;
  subText?: string;
  size?: "xlarge" | "large" | "medium" | "small" | "xsmall";
  avatarBgColor?: string;
  avatarFaIcon?: IconDefinition;
  avatarShape?: "Circle" | "RoundedSquare";
  style?: React.CSSProperties;
  textColor?: string;
  showFullName?: boolean;
}

export const Avatar: FC<AvatarProps> = (props) => {
  const {
    avatarClass,
    avatarStyleObj,
    style,
    imageSrc,
    imageAltText,
    contentStyle,
    avatarFaIcon,
    iconClassName,
    circleText,
    subText,
    rightSideContent,
  } = useAvatar(props);

  return (
    <div className="ucl-avatar-outer">
      <div className="ucl-avatar-block">
        <div className={avatarClass} style={{ ...avatarStyleObj, ...style }}>
          {!!imageSrc ? (
            <img className="image" src={imageSrc} alt={imageAltText} />
          ) : !!avatarFaIcon ? (
            <span className="ucl-avatar-faicon" style={contentStyle}>
              <FontAwesomeIcon
                icon={avatarFaIcon}
                style={{ fontSize: "1em" }}
              />
            </span>
          ) : !!iconClassName ? (
            <div
              className={`${iconClassName} icons`}
              style={contentStyle}
            ></div>
          ) : (
            <span className="e-avatar-text" style={contentStyle}>
              {circleText}
            </span>
          )}
        </div>
        {!!subText && <div className="ucl-avatar-subtext">{subText}</div>}
      </div>
      {!!rightSideContent && (
        <span className="ucl-avatar-right-side-content">
          {rightSideContent}
        </span>
      )}
    </div>
  );
};

export default Avatar;
